import { render, staticRenderFns } from "./OnboardingBox.vue?vue&type=template&id=9a5a62a0&scoped=true"
import script from "./OnboardingBox.vue?vue&type=script&lang=js"
export * from "./OnboardingBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5a62a0",
  null
  
)

export default component.exports